// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_BuscaWhatsappDevicesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas/buscaWhatsappDevices
 *
 * No body required — endpoint lists WhatsApp devices accessible to the
 * authenticated user. The empty contract exists to register the input
 * option string with the runtime registry.
 */
import { registerContract } from './validate'

export interface MensagensProgramadas_BuscaWhatsappDevicesInput {}

registerContract('MensagensProgramadas_BuscaWhatsappDevicesInput', {})
